import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=2bc7a9e6&"
import script from "./RawData.vue?vue&type=script&lang=js&"
export * from "./RawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports